module.exports = __webpack_public_path__ + "static/media/CRC55.534ec7d5.otf";